import { useNavigate } from "react-router-dom";

export function LogoHeader() {
  const navigate = useNavigate();

  const handleHome = () => navigate('/')
  
  return (
    <div onClick={handleHome} className="border-b border-border py-4 flex justify-center cursor-pointer">
      <img src="/logo.png" alt="logo" className="w-[180px]" />
    </div>
  )
}